// extracted by mini-css-extract-plugin
export default {"CCTablePaginationContainer":"CCTable_CCTablePaginationContainer__+wx66","CCTableDataContainer":"CCTable_CCTableDataContainer__BGhbc","CCTable":"CCTable_CCTable__3DONu"};